export const URL_FUNCION =
  "/Seguridad/WebService/SeguridadWebService.asmx/BuscarFuncionesPorPerfil";
export const URL_ACTUALIZAR_FUNCIONES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarFuncionesPerfil";
export const URL_OBTENER_PERFILES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerPerfilesAImportar";
export const URL_IMPORTAR_PERFIL =
  "/Seguridad/WebService/SeguridadWebService.asmx/ImportarPerfil";
export const URL_OBTENER_USUARIO_LOGIN =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerUsuarioLogin";
export const URL_OBTENER_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerCompania";
export const URL_ACTUALIZAR_INFORMACION_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarInformacionCompania";
    

